export const CANCEL_ORDER_MODAL_OPEN = 'CANCEL_ORDER_MODAL_OPEN';
